













































import {Component, Vue, Model,Prop} from 'vue-property-decorator';
import qiniuUpload from './qiniuupload';
import _ from 'lodash';

@Component
export default class SingleImgUpload extends Vue {
  @Model('change', {type: Object})
  readonly file !: {
    name: string;
    url: string;
  };

  @Prop()
  showFinish!: boolean;

  get fileList() {
    if (_.isEmpty(_.get(this.file, 'url', ''))) {
      return [];
    }
    return [this.file];
  }

  get hiddenUploadBtn(): boolean {
    return !_.isEmpty(_.get(this.file, 'url', ''))
  }

  dialogImageUrl = '';
  dialogVisible = false;
  disabled = false;

  uploadFile(options: any) {
    return qiniuUpload(options).then((file) => {
      this.$emit('change', file)
    });
  }

  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  handleRemove() {
    this.clear();
  }

  handleDownload(file: any) {
    //这是删除.
    console.log(file);
  }

  clear(){
    this.file.url = "";
    this.file.name = "";
    this.dialogImageUrl = "";
  }
  finish() {
    this.$emit('completeUpload', this.file);
    this.clear();

  }
}
